import GraphQLClientService from '../../services/GraphQLClientService';
import { LOD2BuildingEntity } from '../../ResponseObjects/Schemas/BuildingEntity';
import { Stage,GeometryType } from '../../constants/progress';
import { useProgressStore } from '../../store/progressStore';
import { BBOxRelativeToCenter } from '../../services/MercatorRelativeToCenter';
import { useMapStore } from '../../store/useMapStore';

export default async function fetchBuildingData(minX, minY, maxX, maxY) {
  const updateProgress = useProgressStore.getState().updateProgress;
  const center = useMapStore.getState().center;
  const geometryType = GeometryType.BUILDINGS;
  const bbox = [minX,minY,maxX,maxY]
  // Validate parameters
  const relativebbox = BBOxRelativeToCenter([minX,minY,maxX,maxY], center)
  //console.log("BoundingBox relative to center",relativebbox)
  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing boundingbox",
      error:"All boundary parameters (minX, minY, maxX, maxY) are required"
    });
    
    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }
  updateProgress(geometryType,{
    stage: Stage.QUERY,
    message:'Fetching data from server',
    progress: 25,
    error: null
  });

    const query = `query {
      buildingByBounds( 
        minLat: ${maxY}
        minLon:${maxX}
        maxLat: ${minY}
        maxLon: ${minX}
        outputCRS: EPSG25832
        revitProtocol: true
        )   {
            buildings {
            municipalityKey
            municipalityName
            parcelIdentifier
            measuredHeight
            sourceFile
            lastUpdated
            id
            objectId
            objectType
            lod
            function
            roofShape
            area
            volume
            parentId
              surfaces 
              {
                objectType
                maxHeight
                minHeight
                  geometry {
                    bbox
                    coordinates
                    crs
                    type
                  }
                  objectType
                }
              }
          }
    }`;

  const client = new GraphQLClientService();

  try {
    console.log(query);
    const response = await client.executeQueryAsync(query);
   // console.log("Response from api", response)

    if(response == "TimedOUT")
    {
        updateProgress(geometryType,{
        stage: Stage.TIMEDOUT,
        message: 'Timed out',
        progress: 0,
       
      })
      return null;

    }   
    else{
          if (response.data.buildingByBounds.buildings.length>0) {
          updateProgress(geometryType,{
            stage: Stage.QUERYSTAGE,
            message: 'Fetched data from the server',
            progress: 50,
            fetched: response.data.buildingByBounds.buildings.length
          })
          const buildingEntities = LOD2BuildingEntity.fromResponse(response, relativebbox);
          
          updateProgress(geometryType,{
            stage: Stage.PROCESSINGSTAGE,
            message:'Processed fetched data from the server',
            progress: 50,// need to change
            processed: buildingEntities.length
          })
          return buildingEntities;
        } else {
          updateProgress(geometryType,{
            stage: Stage.NULL,
            message:'No data returned or an error occurred.',
            error:'No data returned or an error occurred.'
          })
          console.log('No data returned or an error occurred.');
          return null;
        }
      } 
    } 
    catch (error)
    {
      updateProgress(geometryType,{
        stage: Stage.ERROR,
        message:'Error during GraphQL request:',
        error: error
      })
      console.error('Error during GraphQL request:', error);
      throw error; 
    }
  
}